import React, { FC, ReactNode } from "react";
import cn from "clsx";

/**
 * The only purpose of this component is to show a properly styled vertical list
 * of images on SSR (by overlapping the list of Slider) until the Slider is not
 * initialized during its lifecycle
 */

const SideImagesStatic: FC<{
  className?: string;
  children: ReactNode;
}> = ({ className, children }) => {
  return (
    <div
      className={cn(
        className,
        "slick-slider thumb-side-gallery thumb_sliding slick-vertical slick-initialized",
        "static_slider"
      )}
    >
      <div className="slick-list">
        <div className="slick-track">{children}</div>
      </div>
    </div>
  );
};

export default SideImagesStatic;
